// extracted by mini-css-extract-plugin
export default {"search":"TherapistStep2_search__i1TyC"};